package com.rosario.juridico.domain

import com.rosario.juridico.marketplace.model.Expediente
import com.rosario.juridico.marketplace.model.Movimiento
import com.rosario.juridico.marketplace.model.Tarea
import com.rosario.juridico.platform.FirebaseProxy
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

class ExpedienteRepository {

    fun getExpedientes(userId: String): Flow<List<Expediente>> = flow {
        emit(FirebaseProxy.getExpedientes(userId))
    }

    suspend fun getTareas(expedienteId: String): List<Tarea> {
        return FirebaseProxy.getTareas(expedienteId)
    }

    suspend fun crearExpediente(userId: String, expediente: Expediente): String {
        return FirebaseProxy.addExpediente(userId, expediente)
    }

    suspend fun actualizarExpediente(userId: String, expediente: Expediente) {
        FirebaseProxy.updateExpediente(userId, expediente)
    }

    suspend fun agregarTarea(expedienteId: String, tarea: Tarea): String {
        return FirebaseProxy.addTarea(expedienteId, tarea)
    }

    // ── Movimientos procesales ────────────────────────────────────────────────
    suspend fun getMovimientos(userId: String, expedienteId: String): List<Movimiento> {
        return FirebaseProxy.getMovimientos(userId, expedienteId)
    }

    suspend fun agregarMovimiento(userId: String, expedienteId: String, movimiento: Movimiento): String {
        return FirebaseProxy.addMovimiento(userId, expedienteId, movimiento)
    }

    suspend fun actualizarMovimiento(userId: String, expedienteId: String, movimiento: Movimiento) {
        FirebaseProxy.updateMovimiento(userId, expedienteId, movimiento)
    }

    suspend fun eliminarMovimiento(userId: String, expedienteId: String, movimientoId: String) {
        FirebaseProxy.eliminarMovimiento(userId, expedienteId, movimientoId)
    }
}
